<template>
  <main>
    <tab-header />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h4 class="text-green">
                        轄下服務件資訊
                    </h4>

                    <div class="breadcrumb row" v-if="tableRow && tableRow.length">
                        <label class="col-1 text-right">路徑</label>
                        <div class="col-7">
                            <ul class="breadcrumb-list">
                                <li class="bread"
                                :class="{
                                'active': bread.level === currentLevel
                                }"
                                v-for="(bread, i) in breadCrumbs"
                                :key="`bread-${i}`">
                                    <a role="button" @click="currentLevel = bread.level">{{bread.name}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-4 text-left">
                              <a class="btn btn-default" @click="download(breadCrumbs[currentLevel - 1])" >下載本頁資料</a>
                              <a v-if="checkRoleIdIsQualified" @click.prevent="panelOpen('ceadcdChooseModal2Open')" class="btn btn-default">下載轄下資料</a>
                        </div>
                    </div>

                </div>
                <div class="col-12" :class="{'section-loading': isDataTreeLoading}">
                    <div class="table datatable insurance-green"  v-if="!breadCrumbs.length">
                      無資料!!!!!
                    </div>

                    <table class="table datatable insurance-green"  v-else-if="breadCrumbs[currentLevel - 1].target == '5' || breadCrumbs[currentLevel - 1].target == '6'">
                        <thead>
                            <tr>
                                <th rowspan="3" width="15%">單位</th>
                                <!-- <th class="text-center" colspan="2">近一年業績表現</th> -->
                                <th class="text-center" colspan="4">服務件分佈</th>
                                <th class="text-center">合計</th>
                            </tr>
                            <tr>
                              <!-- <th class="text-right" rowspan="2">業P<br/>(達成率)</th>
                              <th class="text-right" rowspan="2">人均產能<br/>(職達率)</th> -->
                              <th class="text-right" colspan="2">自招件數(要保人數)</th>
                              <th class="text-right" colspan="2">非自招件數(要保人數)</th>
                              <th class="text-right" rowspan="2">自招件數 ＋ 非自招件數 (要保人數*) </th>
                            </tr>
                            <tr>
                              <th class="text-right">轄區</th>
                              <th class="text-right">遠籍</th>
                              <th class="text-right">轄區</th>
                              <th class="text-right">遠籍</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length && !isDataTreeLoading">
                          <tr v-for="(row, rid) in tableRow" :key="`row-${rid}`">
                            <td>{{row.name}}</td>
                            <!-- <td class="text-right">
                              {{row.t2 | pointFormat}}<br/>
                              <small>({{row.t3 | pointFormat}}%)</small>
                            </td>
                            <td class="text-right">
                              {{row.t5 | pointFormat}}<br/>
                              <small>({{row.t4 | pointFormat}}%)</small>
                            </td> -->
                            <td class="text-right">
                              {{row.t9 | emptyField}}<br/>
                              <small>({{row.t10 | emptyField}})</small>
                            </td>
                            <td class="text-right">
                              {{row.t11 | emptyField}}<br/>
                              <small>({{row.t12 | emptyField}})</small>
                            </td>
                            <td class="text-right">
                              {{row.t13 | emptyField}}<br/>
                              <small>({{row.t14 | emptyField}})</small>
                            </td>
                            <td class="text-right">
                              {{row.t15 | emptyField}}<br/>
                              <small>({{row.t16 | emptyField}})</small>
                            </td>
                            <td class="text-right">
                              {{row.total_p | emptyField}}<br/>
                              <small>({{row.total_c | emptyField}})</small>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="currentLevel && tableRow && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="8">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="empty-block bg-white" colspan="8">
                                    <h1 class="bg-white">點擊查詢顯示資料</h1>
                                </td>
                            </tr>
                        </tbody>
                        <!-- <tfoot>
                          <tr>
                            <th class="text-left">合計</th>
                            <th class="text-right">
                              {{countTotal('pNumber')}}<br/>
                              <small>{{countTotal('pRate')}}%</small>
                            </th>
                            <th class="text-right">
                              {{countTotal('capacity')}}<br/>
                              <small>{{countTotal('capacityRate')}}%</small>
                            </th>
                            <th class="text-right">
                              {{countTotal('self_in_area_number')}}<br/>
                              <small>{{countTotal('self_in_area_number2')}}</small>
                            </th>
                            <th class="text-right">
                              {{countTotal('self_out_area_number')}}<br/>
                              <small>{{countTotal('self_out_area_number2')}}</small>
                            </th>
                            <th class="text-right">
                              {{countTotal('notSelf_in_area_number')}}<br/>
                              <small>{{countTotal('notSelf_in_area_number2')}}</small>
                            </th>
                            <th class="text-right">
                              {{countTotal('notSelf_out_area_number')}}<br/>
                              <small>{{countTotal('notSelf_out_area_number2')}}</small>
                            </th>
                            <th class="text-right">
                              {{countTotal('total')}}<br/>
                              <small>{{countTotal('total2')}}</small>
                            </th>
                          </tr>
                        </tfoot> -->
                    </table>

                    <table class="table datatable insurance-green" v-else>
                        <thead>
                            <tr>
                                <th rowspan="3">單位</th>
                                <!-- <th colspan="3" class="text-center">當工組織</th> -->
                                <!-- <th colspan="2" class="text-center">近一年業績表現</th> -->
                                <th colspan="4" class="text-center">服務件分佈</th>
                                <th class="text-center" width="15%">合計</th>
                            </tr>
                            <tr>
                              <!-- <th rowspan="2" class="text-right">組織<br/>人數</th>
                              <th rowspan="2" class="text-right">新進<br/>人員</th>
                              <th rowspan="2" class="text-right">脫落<br/>人員</th>
                              <th rowspan="2" class="text-right">業P<br/>(達成率)</th>
                              <th rowspan="2" class="text-right">人均產能<br/>(職達率)</th> -->
                              <th colspan="2" class="text-center">自招件數(要保人數)</th>
                              <th colspan="2" class="text-center">非自招件數(要保人數)</th>
                              <th rowspan="2" class="text-right">自招件數 ＋ <br> 非自招件數 <br> (要保人數*) </th>
                            </tr>
                            <tr>
                              <th class="text-right">轄區</th>
                              <th class="text-right">遠籍</th>
                              <th class="text-right">轄區</th>
                              <th class="text-right">遠籍</th>
                            </tr>
                        </thead>
                        <tbody v-if="tableRow && tableRow.length && !isDataTreeLoading">
                          <tr v-for="(row, rid) in tableRow" :key="`row-${rid}`">
                            <td>
                              <a v-if="row.child" @click="getNewLevelInfo(row)" class="link text-underline">{{row.org_name}}</a>
                              <span v-else>{{row.org_name}}</span>
                            </td>
                            <!-- <td class="text-right">
                              {{row.t6 | emptyField}}
                            </td>
                            <td class="text-right">
                              {{row.t7 | emptyField}}
                            </td>
                            <td class="text-right">
                              {{row.t8 | emptyField}}
                            </td> -->
                            <!-- <td class="text-right">
                              {{row.t2 | pointFormat}}<br/>
                              <small>({{row.t3 | pointFormat}}%)</small>
                            </td>
                            <td class="text-right">
                              {{row.t5 | pointFormat}}<br/>
                              <small>({{row.t4 | pointFormat}}%)</small>
                            </td> -->
                            <td class="text-right">
                              {{row.t9 | emptyField}}<br/>
                              <small>({{row.t10 | emptyField}})</small>
                            </td>
                            <td class="text-right">
                              {{row.t11 | emptyField}}<br/>
                              <small>({{row.t12 | emptyField}})</small>
                            </td>
                            <td class="text-right">
                              {{row.t13 | emptyField}}<br/>
                              <small>({{row.t14 | emptyField}})</small>
                            </td>
                            <td class="text-right">
                              {{row.t15 | emptyField}}<br/>
                              <small>({{row.t16 | emptyField}})</small>
                            </td>
                            <td class="text-right">
                              {{row.total_p | emptyField}}<br/>
                              <small>({{row.total_c | emptyField}})</small>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else-if="tableRow && !tableRow.length">
                            <tr>
                                <td class="empty-block bg-white" colspan="11">
                                    <h1 class="bg-white">無任何資料</h1>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   
                    <div v-if="tableRow && tableRow.length">
                        <p>合計要保人數包含自招件及非自招件，可能有部分要保人重複的情形，故採用歸戶方式計算要保人數。</p>
                    </div>
                </div>

            </div>
        </div>
      </div>
    </div>

    <Ceadcd-Choose-Modal2
      :open="ceadcdChooseModal2Open"
      :roleId="this.$store.state.userInfo.roleId"
      :userCategoryId="this.$store.state.userInfo.userCategoryId"
      @close="panelClose('ceadcdChooseModal2Open')"
      @choose="chooseCeadcd"
    />

  </main>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import TabHeader from '@/desktop/components/manager/TabHeader'
import CeadcdChooseModal2 from '../manager/condition/components/CeadcdChooseModal2' 
import { downloadStatsBZ, queryNrechargeInfo,downloadNrechargeInfo, downloadNrechargeInfo2 } from '@/service'


export default {
  name: 'TransferTab63',
  mixins: [commonMixin],
  components: {
    TabHeader, CeadcdChooseModal2
  },
  computed: {
    tableRow () {
      this.checkBreadCrumbs()
      return this.dataTree[this.currentLevel - 1]
    },
    checkRoleIdIsQualified(){
      let isQualified = false;
      const userCategoryId = this.$store.state.userInfo.userCategoryId
      switch(this.$store.state.userInfo.roleId) {
        case 'SALES_MANAGER_01':   // 協理
        case 'SALES_01':  // 區專
          isQualified = true;
          break;
        case 'SALES_MANAGER_02': // 主管(經理)
          if(userCategoryId == 'A043'){
            isQualified = true
          }    
          break;
        default:
          break
      }
      return isQualified
    },
  },
  data () {
    return {
      connectModalOpen: false,
      ceadcdChooseModal2Open: false,
      order: {
          index: 1,
          asc: true
      },
      dataTree: [],
      breadCrumbs: [],
      currentLevel: 0,
      isDataTreeLoading: false,
      district: 0,
    }
  },
  watch: {
    currentLevel() {
      this.isDataTreeLoading = true;
      setTimeout(() => {
        this.isDataTreeLoading = false;
        this.registerHanlink()
      }, 200)
    }
  },
  methods: {
    ...mapActions([
      'setPageLock'
    ]),
    columnSorting(i) {
        if (this.order.index == i) {
            this.order.asc = !this.order.asc
        } else {
            this.order.asc = true
        }
        this.order.index = i
    },
    checkBreadCrumbs() {
      this.breadCrumbs.length = this.currentLevel
      this.dataTree.length = this.currentLevel
    },
    getNewLevelInfo(row) {
      const newBreadCrumbs = {
          level: this.currentLevel + 1,
          target: this.findTarget(row),
          name: row.org_name,
          group: row.org_no
      }
      this.getNrechargeInfo(newBreadCrumbs)
    },
    findTarget(row) {
      let lastTarget = this.breadCrumbs[this.breadCrumbs.length - 1].target
      if(this.$store.state.userInfo.divNo.slice(2,3) == '1') {
        // 專招人員
        switch(lastTarget) {
          case '1':
            return '2';
          case '2':
            return '5';
          default:
            this.$toast.info({title: '查詢失敗,請重新操作(api_id error)'})
            break;
        }
      } else if(this.$store.state.userInfo.divNo.slice(2,3) == '4') {
        // 展業人員
        switch(lastTarget) {
          case '1':
            return '3';
          case '3':
            return '4';
          case '4':
            return '6';
          default:
            this.$toast.info({title: '查詢失敗,請重新操作(api_id error)'})
            break;
        }
      } else  {
        // 協理
        const group = row.org_no.slice(2,3) // 1:專招  4:展業
        if( lastTarget == '1'){
          // 查詢區部轄下通訊處
          return '0'
        } else {
          if( group == '1' ){
            //專招
            switch(lastTarget) {
              case '0':
                return '2';
              case '2':
                return '5';
              default:
                this.$toast.info({title: '查詢失敗,請重新操作(api_id error)'})
                break;
            }
          } else {
            //展業
            switch(lastTarget) {
              case '0':
                return '3';
              case '3':
                return '4';
              case '4':
                return '6';
              default:
                this.$toast.info({title: '查詢失敗,請重新操作(api_id error)'})
                break;
            }
          }
        }

      }
    },
    getNrechargeInfo(breadCrumbs) {
      this.isDataTreeLoading = true;
      const roleId = this.$store.state.userInfo.roleId
      queryNrechargeInfo(this.$store.state.userInfo.id, breadCrumbs.target, breadCrumbs.group, 
        this.$store.state.userInfo.divNo, this.$store.state.userInfo.mktDeptNo, roleId).then(result => {
          if(result.header && result.header.status == '200') {
            let data = Object.values(result.body)[0].map(eachRow => {
              if(breadCrumbs.target == '1') {
                if(eachRow.org_no == this.$store.state.userInfo.divNo) {
                  eachRow['child'] = true
                }
              } else {
                if(eachRow.t6 || eachRow.t9) {
                  eachRow['child'] = true
                }
              }
              if(eachRow['org_name'] == '合計' || eachRow['name'] == '合計') {
                eachRow['child'] = false
              }
              if(breadCrumbs.level == '2' && breadCrumbs.name.includes('區部')) {
                const type = eachRow['org_no'].substr(2,1)
                if( type == '1' ){
                  eachRow['org_name'] = '專招' + eachRow['org_name']
                } else if ( type == '4' ){
                  eachRow['org_name'] = '展業' + eachRow['org_name']
                }
              }
              return eachRow
            })
            this.dataTree.push(data)
            this.currentLevel++ 
            this.breadCrumbs.push(breadCrumbs)
            
          } else {
            if(result.header.message) {
              this.$toast.info({title: result.header.message})
            } else {
              this.$toast.info({title: '查詢失敗,請重新操作'})
            }
          }

          this.isDataTreeLoading = false;
          setTimeout(() => {
            this.registerHanlink()
            console.log('update')
          }, 200);
      })
    },
    download(breadCrumb) {
      this.changeLoading = true;
      downloadNrechargeInfo(this.$store.state.userInfo.id, breadCrumb.target, this.$store.state.userInfo.roleId, breadCrumb.group, 
        this.$store.state.userInfo.divNo, this.$store.state.userInfo.mktDeptNo).then(result => {
        if (result.type == "application/json") {
          //  json 為檔案下載失敗
          //  把回傳的 blob 轉為 文字檔後再用 json parse
          let reader = new FileReader();
          reader.onload = function() {
            let unicodeJsonA = JSON.parse(reader.result);
            if (unicodeJsonA.header.message) {
              vm.setToastMsg(unicodeJsonA.header.message);
            } else {
              vm.setToastMsg("伺服器連線異常");
            }
          };
          reader.readAsText(result);
        } else {
          //  成功取得檔案  進行下載
          var fileName = "轄下服務件資訊";
          fileName += `-${new Date().getTime()}.xlsx`;

          saveAs(result, fileName);
        }

        this.changeLoading = false;
      });
    },
    chooseCeadcd(val) {
      this.panelClose('ceadcdChooseModalOpen');
      this.downloadData2(val);
    },
    downloadData2(val) {
      this.isDataTreeLoading = true;
      downloadNrechargeInfo2(this.$store.state.userInfo.id, this.$store.state.userInfo.roleId, this.$store.state.userInfo.divNo, val).then(result => {
          if (result.type == "application/json") {
            //  json 為檔案下載失敗
            //  把回傳的 blob 轉為 文字檔後再用 json parse
            let reader = new FileReader();
            reader.onload = function() {
              let unicodeJsonA = JSON.parse(reader.result);
              if (unicodeJsonA.header.message) {
                vm.setToastMsg(unicodeJsonA.header.message);
              } else {
                vm.setToastMsg("伺服器連線異常");
              }
            };
            reader.readAsText(result);
          } else {
            //  成功取得檔案  進行下載
            let fileName;
            if(val == '0'){
              fileName = '區部轄下通訊處.xlsx';
            }else if(val =='2'){
              fileName = '專招轄下推展處.xlsx';
            }else if(val =='3'){
              fileName = '展業轄下展業課.xlsx';
            }else if(val =='4'){
              fileName = '展業轄下展業區.xlsx';
            }

            saveAs(result, fileName);
          }

          this.isDataTreeLoading = false;
        });
    },
    initTransferTab63() {
      this.dataTree = []
      this.breadCrumbs = []
      this.currentLevel = 0
      let firstBread = {
        level: 1,
        target: '',
        name: '',
        group: null
      }
      switch(this.$store.state.userInfo.roleId) {
        case 'SALES_MANAGER_01':   // 協理
        case 'SALES_01':           // 區專
        case 'SALES_MANAGER_02':
          // 主管(經理)
        case 'SALES_MANAGER_05':
          // 主管(組訓)
          firstBread.target = '1'
          firstBread.name = '全部'
          break;
        case 'SALES_MANAGER_06':
          //被授權者
          if(this.$store.state.userInfo.userCategoryId =='A019'){
            firstBread.target = '1'
            firstBread.name = '全部'
            break;
          }else if(this.$store.state.userInfo.userCategoryId =='A044'){
            firstBread.group = this.$store.state.userInfo.divNo
            firstBread.target = '4'
            firstBread.name = this.$store.state.userInfo.divFullName
            break;
          }
          else{
            // (區主任/處長)
            firstBread.group = this.$store.state.userInfo.divNo
            if(this.$store.state.userInfo.divNo.slice(2,3) == '1') {
            // 專招人員
              firstBread.target = '5'
              firstBread.name = this.$store.state.userInfo.divFullName
            }
            if(this.$store.state.userInfo.divNo.slice(2,3) == '4') {
              // 展業人員
              firstBread.target = '6'
              firstBread.name = this.$store.state.userInfo.divFullName
            }
            break;
          }          
        case 'SALES_MANAGER_03':
          // 主管(課長)
          firstBread.group = this.$store.state.userInfo.divNo
          firstBread.target = '4'
          firstBread.name = this.$store.state.userInfo.divFullName
          break;
        case 'SALES_MANAGER_04':
          // (區主任/處長)
          firstBread.group = this.$store.state.userInfo.divNo
          if(this.$store.state.userInfo.divNo.slice(2,3) == '1') {
            // 專招人員
            firstBread.target = '5'
            firstBread.name = this.$store.state.userInfo.divFullName
          }
          if(this.$store.state.userInfo.divNo.slice(2,3) == '4') {
            // 展業人員
            firstBread.target = '6'
            firstBread.name = this.$store.state.userInfo.divFullName
          }
          break;
        default:
          this.$toast.info({title:'您無使用此頁面之權限！'})
          return;
      }
      this.getNrechargeInfo(firstBread)
    }
  },
  beforeMount () {
    this.initTransferTab63()
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
   #app.manager .row {
     justify-content: center;
     align-items: center;
   }
</style>
